import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=4a6714aa&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6714aa')) {
      api.createRecord('4a6714aa', component.options)
    } else {
      api.reload('4a6714aa', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=4a6714aa&", function () {
      api.rerender('4a6714aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iZFcx0xHD1aS/JS/offershelp.vue"
export default component.exports